import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})

export class CookiesStorage {
  public static secretKey = environment.CryptoJSKey;
  public static Encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }
  public static Decrypt(textToDecrypt: string) {
    if (textToDecrypt == '') {
      return null;
    }
    try {
      return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return null;
    }
  }

  public static setCookie(name: string, value: any) {
    value = (value == null || value == undefined) ? "" : this.Encrypt(value.toString());
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  public static getCookie(name: string) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return this.Decrypt(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  public static eraseCookie(name: string) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

  public static deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      //document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = name + "=; Max-Age=-99999999;";

    }
  }
}
